module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('progress-bar'), _vm._v(" "), _c('sound-toggle'), _vm._v(" "), _c('login-view', {
    on: {
      "log-in": _vm.logIn,
      "log-out": _vm.logOut
    }
  }), _vm._v(" "), _c('router-view', {
    on: {
      "save-score": _vm.saveScore
    }
  }), _vm._v(" "), (_vm.routePath === '/') ? _c('credits', {
    staticClass: "credits"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b50b486e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 148
// module chunks = 1